if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      document.body.classList.remove('u-overflow-hidden');
      this.modalOpenerVideo = document.querySelectorAll('modal-opener video');
      if(this.modalOpenerVideo.length > 0) {
        this.modalOpenerVideo.forEach((el => {
          el.play()
        }));
      }
    }

    show(opener) {
      super.show(opener);
      document.body.classList.add('u-overflow-hidden');
      this.videoProductModal = document.querySelectorAll('product-modal video');
      if(this.videoProductModal.length > 0) {
        this.videoProductModal.forEach((el => {
          el.play()
        }));
      }
    }
  });
}
